import BaseAPI from '@/apis/base/baseApi';
export default class GLApi extends BaseAPI {
  apiName = 'GL';
}
